<template>
    <aside
        v-show="!isFullScreen"
        class="shadow-xl fixed top-15 z-10 h-screen bg-gradient-to-bl bg-white via-blue-50 to-white border-r border-gray-300 transition-position xl:left-0 overflow-y-auto
    scrollbar-thin scrollbar-thumb-rounded scrollbar-thumb-gray-600 scrollbar-track-white
    dark:scrollbar-track-gray-800 dark:bg-gray-900"
        :class="[ isAsideMobileExpanded ? 'w-72' : 'w-[88px]']"
    >
        <template
            v-if="!isAsideMobileExpanded"
        >
            <div class="flex flex-row w-full bg-green-500 text-white flex-1 items-center">
                <nav-bar-item
                    type="hidden lg:hidden xl:hidden"
                    active-color="text-white"
                    active
                    @click="asideLgClose"
                >
                    <icon
                        :path="mdiMenu"
                        class="cursor-pointer"
                        size="24"
                    />
                </nav-bar-item>
            </div>
            <div class="h-[calc(100%-9rem)]">
                <template v-for="(menuGroup, index) in menu">
                    <p
                        v-if="typeof menuGroup === 'string'"
                        :key="`a-${index}`"
                        class="p-3 text-xs uppercase text-gray-400"
                    >
                        {{ menuGroup }}
                    </p>
                    <aside-menu-list
                        v-else
                        :key="`b-${index}`"
                        :menu="menuGroup"
                        :is-aside-mobile="isAsideMobileExpanded"
                        :show-submenu-info="showSubmenuInfo"
                        @menu-click="menuClick"
                        @toggle-sidebar="toggleSidebar"
                    />
                </template>
            </div>
        </template>
        <template
            v-else
        >
            <div class="flex flex-row w-full bg-green-500 text-white flex-1 items-center">
                <nav-bar-item
                    type="hidden lg:hidden xl:hidden"
                    active-color="text-white"
                    active
                    @click="asideLgClose"
                >
                    <icon
                        :path="mdiMenu"
                        class="cursor-pointer"
                        size="24"
                    />
                </nav-bar-item>
            </div>
            <div class="h-[calc(100%-9rem)]">
                <template v-for="(menuGroup, index) in menu">
                    <p
                        v-if="typeof menuGroup === 'string'"
                        :key="`a-${index}`"
                        class="p-3 text-xs uppercase text-gray-400"
                    >
                        {{ menuGroup }} 
                    </p>
                    <aside-menu-list
                        v-else
                        :key="`b-${index}`"
                        :menu="menuGroup"
                        :is-aside-mobile="isAsideMobileExpanded"
                        :show-submenu-info="showSubmenuInfo"
                        @menu-click="menuClick"
                        @toggle-sidebar="toggleSidebar"
                    />
                </template>
            </div>
        </template>
    </aside>
</template>

<script>
import { computed, inject } from 'vue'
import { useStore } from 'vuex'
import AsideMenuList from '@/components/Utilities/AsideMenuList'
import Icon from '@/components/Utilities/Icon'
import NavBarItem from '@/components/Utilities/NavBarItem'
import { mdiMenu } from '@mdi/js'
// import UserAvatar from '@/components/Utilities/UserAvatar'

export default {
    name: 'AsideMenu',
    components: {
        AsideMenuList,
        NavBarItem,
        Icon
        // UserAvatar
    },
    props: {
        menu: {
            type: Array,
            default: () => []
        }
    },
    emits: ['open-modal'],
    setup (props, { emit }) {
        const store = useStore()
        const isFullScreen = computed(() => store.state.isFullScreen)
        const toggleSidebar = () =>{
            store.dispatch('asideMobileToggle')
        }
        const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
        const isAsideLgActive = computed(() => store.state.isAsideLgActive)
        const asideLgClose = () => {
            store.dispatch('asideLgToggle', false)
        }
        const showSubmenuInfo = computed(() => store.state.showSubmenuInfo)
        const userName = computed(() => {
            const cutLength = 8
            return store.state.userName.length > cutLength ? store.state.userName.slice(0, cutLength) + '...' : store.state.userName
        })

        // const $http = inject('$http')
        const $swal = inject('$swal')

        const confirmGoSpoplus = () => {
            $swal.fire({
                text: 'SPO+ TOPに戻りますか？',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: 'rgba(239,186,99,0.91)',
                confirmButtonText: 'はい',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    goSpoplus()
                }
            })
        }

        const goSpoplus = async () => {
            // await $http.post('logout', {}, false, true)
            // localStorage.removeItem('spoplus-token')
            // sessionStorage.removeItem('skipPayment')
            window.location.href = '/top/'
        }

        const menuClick = (event, item) => {
            if (item?.submenu?.length) {
                if (isAsideMobileExpanded.value) {
                    const payload = {
                        label: item.label
                    }
                    store.dispatch('showSubmenuToggle', payload)
                } else {
                    toggleSidebar()
                    const payload = {
                        isShow: true,
                        label: item.label
                    }
                    store.dispatch('showSubmenuToggle', payload)
                }
            }

            if (item.label === 'お問い合わせ') {
                emit('open-modal', { type: 'inquiry' })
                return
            }

            if (['利用規約', 'プライバシーポリシー'].includes(item.label)) {
                window.open(item.to, '_blank')
                return
            }

            if (item.label === 'Topに戻る') {
                confirmGoSpoplus()
                return
            }

            if (item.externalLink) {
                window.open(item.externalLink, '_blank')
                return
            }
        }

        return {
            toggleSidebar,
            isFullScreen,
            isAsideMobileExpanded,
            isAsideLgActive,
            showSubmenuInfo,
            asideLgClose,
            menuClick,
            mdiMenu,
            userName
        }
    }
}
</script>
